import { DatePicker, type DatePickerProps } from './DatePicker';

// Adapter that lets DatePicker drop into the kit FormField exactly like Input/Select/Textarea.
// The kit FormField signals an error by cloning its child with `aria-invalid`; DatePicker instead
// takes an `error` boolean and does not spread arbitrary props, so translate the injected attribute
// into that prop here. Everything else passes straight through to DatePicker.
export function FormDatePicker({
  error,
  'aria-invalid': ariaInvalid,
  ...rest
}: DatePickerProps & { 'aria-invalid'?: boolean }) {
  return <DatePicker {...rest} error={error === true || ariaInvalid === true} />;
}
